import { render, staticRenderFns } from "./Lnvitation.vue?vue&type=template&id=18b183de&scoped=true"
import script from "./Lnvitation.vue?vue&type=script&lang=js"
export * from "./Lnvitation.vue?vue&type=script&lang=js"
import style0 from "./Lnvitation.vue?vue&type=style&index=0&id=18b183de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b183de",
  null
  
)

export default component.exports